import { Component, Mixins } from 'vue-property-decorator';
import LoginRightIllustration from '../commonComponents/loginRightIllustration/LoginRightIllustration.vue';
import APP_CONST from '@/constants/AppConst';
import commonEntry from '@/store/modules/commonEntry';
import AccountSettings from '@/mixins/accountSettings.mixin';
import LandscapeMode from '@/popupcomponents/landscapemodepopup/LandscapeMode.vue';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { getInstance } from '@/auth';

@Component({
  components: {
    'right-illustration': LoginRightIllustration,
    'landscape-popup': LandscapeMode,
  },
})
export default class RootComponent extends Mixins(AccountSettings) {
  accountDetails: boolean = false;
  public readonly APP_ROUTES = APP_CONST.APP_ROUTES;

  openUrl() {
    window.open(APP_CONST.PRIVACY_POLICY, '_blank');
  }

  /* istanbul ignore next */
  beforeMount() {
    try {
      const accountDesign = JSON.parse(
        String(APP_UTILITIES.getCookie('accountDesign'))
      );
      this.accountDetails = true;
      this.logo = accountDesign && accountDesign.logoUrl;
      this.updateAccountDesignData(accountDesign);
    } catch (error) {
      this.$router.push(APP_CONST.APP_ROUTES.LOGIN.path);
    }
  }
}
